import { PropsWithChildren, ReactElement, useEffect, useCallback } from 'react'
import { Option } from 'components/atoms/inputs/Select/parts/types'
import { Select } from 'components/atoms/inputs/Select/parts/Select'
import { FocusinHandler } from 'handlers/FocusinHandler/FocusinHandler'

type TypeAheadHandlerProps<Value> = {
  context: Select<Value>
  options: Option<Value>[]
}
export const TypeAheadHandler = <Value extends any>(props: PropsWithChildren<TypeAheadHandlerProps<Value>>): ReactElement | null => {
  const {
    context,
    options,
    children,
  } = props

  const { inputRef, patchOptions, isOpen, patchValue } = context
  const { current: inputNode } = inputRef

  useEffect(() => {
    if (!inputNode) {
      return
    }

    const handleInput = (event: Event) => {
      const target = event.target as HTMLInputElement
      if (!target) {
        return
      }

      const { value } = target
      const nextOptions = options.filter(({ label }) => {
        return label.toLocaleLowerCase().indexOf(value) !== -1
      })
      patchOptions(nextOptions)
      isOpen.show()
    }

    inputNode.addEventListener('input', handleInput)
    return () => {
      inputNode.removeEventListener('input', handleInput)
    }
  }, [inputNode, patchOptions, options, isOpen, patchValue])


  const handleBlur = useCallback(() => {
    patchOptions(options)
    patchValue(context.value, { override: true })
  }, [options, patchOptions, patchValue, context.value])

  return (
    <FocusinHandler onBlur={ handleBlur }>
      { children }
    </FocusinHandler>
  )
}
